import * as React from 'react';
import { UI_IS_XS } from 'ui/breakpoints';
import { Button } from 'ui/components';
import { WrappedMessage } from 'utils';
import messages from '../displayMessages';
import { bind } from 'bind-decorator';
import { LxConfig } from 'global/constants';
import { VideoBanner } from './VideoBanner';

interface State {
    isMobileView: boolean;
}

export class AmgenBanner extends React.PureComponent<{}, State> {

    constructor(props: any) {
        super(props);

        this.state = {
            isMobileView: false,
        };
    }

    private mediaQuery = UI_IS_XS;

    public componentDidMount() {
        this.mediaQuery.addListener(this.setIsMobileView);
        this.setIsMobileView();
    }

    @bind private setIsMobileView() {
        this.setState({isMobileView: this.mediaQuery.matches});
    }

    public render() {
        return (
            <>
                <div id='amgen-banner' className='section pale'>
                    <div className='amgen-image'>
                        <img src={`/assets/images/${this.state.isMobileView ? 'amgen-banner-mobile.png' : 'amgen-banner.png'}`} alt='Amgen banner'/>
                    </div>
                    <div className='amgen-banner-description'>
                        <h2><WrappedMessage message={messages.amgenBannerHeading}/></h2>
                        <div className='heading-underline'/>
                        <ul>
                            <li><WrappedMessage message={messages.amgenBannerLineOne}/></li>
                            <li><WrappedMessage message={messages.amgenBannerLineTwo}/></li>
                            <li><WrappedMessage message={messages.amgenBannerLineThree}/></li>
                            <li><WrappedMessage message={messages.amgenBannerLineFour}/></li>
                            <li><WrappedMessage message={messages.amgenBannerLineFive}/></li>
                        </ul>
                        <Button
                            btnStyle='outline'
                            label={messages.learnMoreButtonLabel}
                            onClick={this.onLearnMoreClick}
                        />
                    </div>
                </div>
                <VideoBanner
                    class='section'
                    videoId={LxConfig.HomepageAmgenPromoVideoId}
                    videoImageUrl={LxConfig.HomepageAmgenPromoVideoImageUrl}
                    videoImageTitle={messages.promoVideoIsLoading}
                    heading={messages.amgenVideoHeading}
                    description={messages.amgenVideoDescription}
                />
            </>
        );
    }

    private onLearnMoreClick() {
        window.open('https://www.amgen.com/newsroom/press-releases/2022/06/amgen-foundation-more-than-doubles-commitment-to-labxchange-free-virtual-science-education-platform', '_blank');
    }

}
